import React from 'react';
import accountData from './accountData.json'; 
import { RiRefreshLine } from "react-icons/ri"; 
import './AccountInfo.scss';

const AccountInfo = () => {
  const { paymentMethod, paymentInfo, accountBalance, availableBalance, refreshLabel } = accountData.accountInfo;

  return (
    <div className="account-info-card">
      <div className="account-info-top">
        <span className="account-info-title">{paymentMethod}</span>
        <button className="account-info-action" title={paymentInfo}>
          <RiRefreshLine className="account-info-icon" />
          {refreshLabel}
        </button>
      </div>
      <hr />
      <div className="account-info-balance">        
        <div className="account-balance-amount">
          {accountBalance.amount} <span className="currency">{accountBalance.currency}</span>
        </div>
        <div className="account-balance-available">
          {availableBalance.amount} {availableBalance.currency}
        </div>        
      </div>
      <hr />
      <div className="account-info-top">
        <span className="account-info-title">{paymentMethod}</span>
        <p className="account-info-actiona" title={paymentInfo}>          
        {paymentInfo}
        </p>
      </div>
      <hr />
      <div className="account-info-bottom">
        {availableBalance.currency} {availableBalance.amount}
      </div>
    </div>
  );
};

export default AccountInfo;
